import { useEffect, useState } from 'react'

import type { DualListItem } from '@/component/molecules/DualList/types'
import DualListBoxV2 from '@/utils/models/DualListBoxV2'

type UseDualListStateOptions<T extends DualListItem> = {
  /** 전체 아이템 목록 */
  items: T[]
  /** 초기 선택된 아이템 ID 목록 */
  initialRightItemIds?: Array<T['id']>
}

type UseDualListStateReturn<T extends DualListItem> = {
  /** DualListBox 인스턴스 */
  dualListBox: DualListBoxV2<T> | null
}

/**
 * DualListBox 상태 관리를 위한 공통 훅
 * - items가 변경되거나 initialRightItemIds가 변경되면(값 기반 비교) DualListBox를 자동으로 재생성
 */
export const useDualListState = <T extends DualListItem>({
  items,
  initialRightItemIds = [],
}: UseDualListStateOptions<T>): UseDualListStateReturn<T> => {
  const [dualListBox, setDualListBox] = useState<DualListBoxV2<T> | null>(null)

  const itemIds = items.map(({ id }) => id).join(',')
  const rightIds = initialRightItemIds.join(',')

  useEffect(() => {
    setDualListBox(new DualListBoxV2<T>({ items, initialRightItemIds }))
  }, [itemIds, rightIds]) // eslint-disable-line react-hooks/exhaustive-deps

  return { dualListBox }
}

export default useDualListState
